// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2t6jIInxzZuJdmDhd9ghH4"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/CategoryTreeModal.scss
// module id = 574
// module chunks = 0 2